(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('ExternalResourceDetailController', ExternalResourceDetailController);

    ExternalResourceDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'ExternalResource', 'AdvertisingSource'];

    function ExternalResourceDetailController($scope, $rootScope, $stateParams, previousState, entity, ExternalResource, AdvertisingSource) {
        var vm = this;

        vm.externalResource = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('telestatApp:externalResourceUpdate', function(event, result) {
            vm.externalResource = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
